<template>
    <section class="abnormal-product">
        <title-date-component :titleOption="titleOption"></title-date-component>
        <section class="data-box">
            <nav-component :type="type" :currentType="rankType" @changeNavType="changeNavType"></nav-component>
            <table-component :tableInfo="tableInfo" style="margin-top:20px;" v-loading="isLoading"></table-component>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .abnormal-product {
        height: 100%;
        width: 50%;
        float: right;
        border-left: 10px solid #F7F9FA;
        background-color: #FFF;
        padding: 10px 20px 10px 20px;
        .data-box {
            width: 100%;
            padding-left: 15px;
            margin-top: 35px;
            padding-bottom: 15px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../../components/title-date/TitleDate.vue'
    import NavComponent from '../../../../components/nav/Nav.vue'
    import TableComponent from '../../../../components/table/Table.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import MomentFormat from '../../../../filters/moment-format'
    import percentformat from '../../../../filters/percent-format'

    export default {
        components: {
            TitleDateComponent,
            NavComponent,
            TableComponent
        },
        data () {
            return {
                titleOption: {
                    title: '7天退步商品'
                },
                type: [
                    {
                        name: '流量下降',
                        value: 'intentionPV'
                    },
                    {
                        name: '访购率下降',
                        value: 'visitPurchaseRate'
                    },
                    {
                        name: '销量下降',
                        value: 'payQuantity'
                    }
                ],
                rankType: 'intentionPV',
                date: {
                    startDate: MomentFormat.getSevenDate(),
                    endDate: MomentFormat.getYestoday()
                },
                resultData: {},
                tableInfo: {
                    title: [
                        {
                            name: '商品名称',
                            value: 'productName',
                            style: 'width:35%;'
                        },
                        {
                            name: '商品编号',
                            value: 'productId'
                        },
                        {
                            name: '浏览量',
                            value: 'intentionPV'
                        },
                        {
                            name: '流量下降',
                            value: 'growthRate'
                        }
                    ],
                    data: []
                },
                color: ['rgba(12, 222, 101, 1)', 'rgba(12, 222, 101, .8)', 'rgba(12, 222, 101, .6)',
                    'rgba(12, 222, 101, .4)', 'rgba(12, 222, 101, .2)'],
                isLoading: false
            }
        },
        props: ["salePlatform"],
        watch: {
            salePlatform: {
                handler: function () {
                    this.getData();
                },
                deep: true
            }
        },
        methods: {
            getData () {
                this.isLoading = true;
                menpiaoDataPlatform.getSevenData(this.salePlatform, this.date.endDate, 1, this.rankType, 1)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let arr = [];
                            let productId = [];
                            data.forEach((item, index) => {
                                let o = {};
                                o.productName = {};
                                o.productName.value = '<span style="background-color:' + this.color[index] + '">' +
                                    (index + 1) + '</span>' + item.productName;
                                o.productId = {};
                                o.productId.value = item.productId;
                                if (this.rankType === 'intentionPV') {
                                    o.intentionPV = {};
                                    o.intentionPV.value = item.week.intentionPV;
                                }
                                if (this.rankType === 'visitPurchaseRate') {
                                    o.visitPurchaseRate = {};
                                    o.visitPurchaseRate.value = percentformat(item.week.visitPurchaseRate, true);
                                }
                                if (this.rankType === 'payQuantity') {
                                    o.payQuantity = {};
                                    o.payQuantity.value = item.week.payQuantity;
                                }
                                o.growthRate = {};
                                o.growthRate.value = item.growthRate;
                                arr.push(o);
                            });
                            this.tableInfo.data = arr;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 切换类型
            changeNavType (type) {
                this.rankType = type;
                let arr = [
                    {
                        name: '商品名称',
                        value: 'productName',
                        style: 'width:25%;'
                    },
                    {
                        name: '商品编号',
                        value: 'productId'
                    }
                ];
                if (this.rankType === 'intentionPV') {
                    arr.push({
                        name: '浏览量',
                        value: 'intentionPV'
                    }, {
                        name: '流量下降',
                        value: 'growthRate'
                    })
                } else if (this.rankType === 'visitPurchaseRate') {
                    arr.push({
                        name: '访购率',
                        value: 'visitPurchaseRate'
                    }, {
                        name: '访购率下降',
                        value: 'growthRate'
                    })
                } else if (this.rankType === 'payQuantity') {
                    arr.push({
                        name: '销量',
                        value: 'payQuantity'
                    }, {
                        name: '销量下降',
                        value: 'growthRate'
                    })
                }
                this.tableInfo.title = arr;
                this.getData();
            }
        },
        mounted () {
            this.getData();
        }
    }
</script>



// WEBPACK FOOTER //
// AbnormalProduct.vue?68703d10